import { ContentPaste, SyncProblem } from "@mui/icons-material";
import { Typography } from "@mui/material";
import { Fragment, useState } from "react";
import Loading from "../../../../components/shared/layout/Loading";
import { CollapsibleItem } from "../../../../components/shared/sidebar/CollapsibleItem";
import { useOSADShipments } from "../../../../hooks/react-query/operations/useOSAD";
import { useSelectedServiceCenter } from "../../../../hooks/useSelectedServiceCenter";
import { osadDefaultValue } from "../../../../mocks/operations/osad.mock";
import { OSADShipmentItem } from "../../inboundPlanning/OSADShipmentItem";
import { NoResultFound } from "./SectionItem";

export const OSAD = () => {
  const [serviceCenter] = useSelectedServiceCenter();
  const [isExpanded, setIsExpanded] = useState(false);

  const { data: osadShipments = osadDefaultValue, isLoading } =
    useOSADShipments(serviceCenter.id);

  if (isLoading) return <Loading />;

  return (
    <CollapsibleItem
      title="OSAD"
      displayCount={osadShipments.summary.bills}
      icon={<SyncProblem />}
      isExpanded={isExpanded}
      onExpand={(value: boolean) => setIsExpanded(value)}
    >
      <>
        {osadShipments.shipments.map((shipment, index) => (
          <Fragment key={shipment.shipmentId}>
            <OSADShipmentItem shipment={shipment} index={index} />
          </Fragment>
        ))}
        {osadShipments.shipments.length === 0 && (
          <NoResultFound>
            <ContentPaste sx={{ fontSize: "2rem" }} />
            <Typography>No OSAD shipments found.</Typography>
          </NoResultFound>
        )}
      </>
    </CollapsibleItem>
  );
};
